// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ny9QUnBNrYkIQ3h2Uxxq{display:none}.ny9QUnBNrYkIQ3h2Uxxq *{pointer-events:none;display:none}.DmEww9TpjW4XA2dMKyH2{justify-content:flex-end;align-items:center;height:16px;margin:0 -4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hidden": `ny9QUnBNrYkIQ3h2Uxxq`,
	"interactionActions": `DmEww9TpjW4XA2dMKyH2`
};
export default ___CSS_LOADER_EXPORT___;
